// HTML
export default `<svg width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 15">
<g>
	<g>
		<path fill="#FFF200" d="M15,11.761c0,0.387-0.313,0.701-0.701,0.701H0.701C0.313,12.461,0,12.148,0,11.761V3.239
			c0-0.387,0.313-0.701,0.701-0.701h13.599C14.687,2.539,15,2.852,15,3.239V11.761z"></path>
	</g>
	<g>
		<g>
			<g>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.492,4.065 4.046,6.38 5.541,7.341 7.295,6.156
					6.644,5.726 7.444,5.175 9.278,6.409 6.093,8.577 6.907,9.106 11.011,6.371 7.492,4.065 				"></polygon>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="9.35,5.054 10.116,5.576 10.857,5.08 10.857,4.056
									"></polygon>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.491,10.943 10.94,8.616 9.441,7.641 7.686,8.839
					8.33,9.273 7.538,9.799 5.688,8.578 8.902,6.417 8.102,5.887 3.989,8.628 3.999,8.637 7.491,10.943 				"></polygon>
			</g>
			<g>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.492,4.133 4.156,6.369 5.544,7.271 7.204,6.153
					6.545,5.721 7.441,5.034 9.509,6.415 6.314,8.569 6.888,8.938 10.761,6.371 7.492,4.133 				"></polygon>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="9.431,5.054 10.125,5.522 10.819,5.054 10.819,4.134
									"></polygon>
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.514,10.768 10.707,8.619 9.436,7.789 7.904,8.833
					8.543,9.266 7.536,9.954 5.471,8.573 8.662,6.419 8.071,6.046 4.221,8.619 				"></polygon>
			</g>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.492,4.206 4.276,6.37 4.156,6.369 7.492,4.133 			"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="8.543,9.266 7.536,9.954 7.536,9.871 8.437,9.267
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="9.436,7.789 7.904,8.833 7.779,8.835 9.438,7.717
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="9.509,6.415 6.314,8.569 6.194,8.569 9.403,6.415
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="8.071,6.046 4.221,8.619 4.101,8.618 8.095,5.959
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.514,10.768 10.707,8.619 10.94,8.616 7.491,10.943
							"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.493,4.205 10.761,6.368 11.011,6.371 7.492,4.065
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="4.276,6.37 5.546,7.194 5.541,7.341 4.046,6.38 			"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.065,6.157 6.429,5.724 7.441,5.034 7.444,5.175
				6.644,5.726 7.295,6.156 			"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="5.546,7.194 7.184,6.083 7.295,6.156 5.541,7.341
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="10.773,4.238 9.551,5.054 9.431,5.054 10.819,4.134
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="10.152,5.458 10.763,5.042 10.819,5.054 10.125,5.522
							"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="9.545,5.056 10.152,5.458 10.125,5.522 9.431,5.054
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="10.763,5.042 10.773,4.238 10.819,4.134 10.819,5.054
							"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="5.608,9.946 4.841,9.424 4.101,9.92 4.101,10.944
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="5.527,9.946 4.833,9.478 4.139,9.946 4.139,10.866
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="4.184,10.761 5.407,9.946 5.527,9.946 4.139,10.866
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="4.806,9.542 4.194,9.958 4.139,9.946 4.833,9.478
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="5.413,9.944 4.806,9.542 4.833,9.478 5.527,9.946
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="4.194,9.958 4.184,10.761 4.139,10.866 4.139,9.946
				"></polygon>
			<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#355FAC" points="7.441,5.034 9.509,6.415 9.278,6.409 7.444,5.175
				"></polygon>
		</g>
	</g>
</g>
</svg>
`